export const CERT_REQUEST = 'cert/CERT_REQUEST'
export const CERT_SUCCESS = 'cert/CERT_SUCCESS'
export const CERT_FAIL = 'cert/CERT_FAIL'
export const CERT_CONFIRM_REQUEST = 'cert/CERT_CONFIRM_REQUEST'
export const CERT_CONFIRM_SUCCESS = 'cert/CERT_CONFIRM_SUCCESS'
export const CERT_CONFIRM_FAIL = 'cert/CERT_CONFIRM_FAIL'
export const CERT_RESET = 'cert/CERT_RESET'

export const certRequest = (userCert) => ({ type: CERT_REQUEST, userCert })
export const certSuccess = (certSeq) => ({ type: CERT_SUCCESS, certSeq })
export const certFail = () => ({ type: CERT_FAIL })
export const certConfirmRequest = (userCert, isSuccessAlert, isFailAlert) => ({ type: CERT_CONFIRM_REQUEST, userCert, isSuccessAlert, isFailAlert })
// certToken: 서버가 인증번호 확인 통과 시 발급하는 일회용 토큰. 후속 API(아이디 찾기, 비밀번호 재설정)에 그대로 전달한다.
export const certConfirmSuccess = (certToken) => ({ type: CERT_CONFIRM_SUCCESS, certToken })
export const certConfirmFail = () => ({ type: CERT_CONFIRM_FAIL })
export const certReset = () => ({ type: CERT_RESET })


const initialState = {
  isRequesting: false,
  isReqeusted: false,
  certSeq: null,
  isConfirmRequesting: false,
  isConfirmRequested: false,
  certToken: null
}

const cert = (state = initialState, action) => {

  switch (action.type) {

    case CERT_REQUEST:
      return {
        ...state,
        isRequesting: true,
        isReqeusted: false,
        certSeq: null
      }
    case CERT_SUCCESS:
      return {
        ...state,
        isRequesting: false,
        isReqeusted: true,
        certSeq: action.certSeq
      }
    case CERT_FAIL:
      return {
        ...state,
        isRequesting: false,
        isReqeusted: false,
        certSeq: null
      }
    case CERT_CONFIRM_REQUEST:
      return {
        ...state,
        isConfirmRequesting: true,
        isConfirmReqeusted: false,
        certToken: null
      }
    case CERT_CONFIRM_SUCCESS:
      return {
        ...state,
        isConfirmRequesting: false,
        isConfirmReqeusted: true,
        certToken: action.certToken
      }
    case CERT_CONFIRM_FAIL:
      return {
        ...state,
        isConfirmRequesting: false,
        isConfirmReqeusted: false,
        certToken: null
      }
    case CERT_RESET:
      return {
        ...state,
        isRequesting: false,
        isReqeusted: false,
        isConfirmRequesting: false,
        isConfirmReqeusted: false,
        certSeq: null,
        certToken: null
      }
    default:
      return state

  }
}

export default cert
